import React from 'react';
import Button from 'sulu-admin-bundle/components/Button';
import DatePicker from 'sulu-admin-bundle/components/DatePicker';
import Divider from 'sulu-admin-bundle/components/Divider';
import Tooltip from 'sulu-admin-bundle/components/Tooltip';

const TIME_PICKER_OPTIONS = {dateFormat: false, timeFormat: true};

const timeToDate = (timeStr) => {
    if (!timeStr) return null;
    const [hours, minutes] = timeStr.split(':');
    const d = new Date();
    d.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    return d;
};

const dateToTime = (date) => {
    if (!date) return '';
    return date.toTimeString().slice(0, 5);
};

const DAYS = [
    {value: 1, label: 'Montag'},
    {value: 2, label: 'Dienstag'},
    {value: 3, label: 'Mittwoch'},
    {value: 4, label: 'Donnerstag'},
    {value: 5, label: 'Freitag'},
    {value: 6, label: 'Samstag'},
];

const styles = {
    wrapper: {
        paddingRight: '24px',
        marginRight: '8px',
        borderRight: '1px solid #e8e8e8',
    },
    dividerWrapper: {
        marginTop: '-50px',
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    table: {
        width: '100%',
        minWidth: '280px',
        borderCollapse: 'collapse',
        fontFamily: 'inherit',
        fontSize: '14px',
    },
    row: {
        borderBottom: '1px solid #e8e8e8',
    },
    dayCell: {
        width: '90px',
        minWidth: '70px',
        padding: '10px 8px 10px 0',
        fontWeight: '600',
        color: '#333',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
    },
    slotsCell: {
        padding: '6px 4px',
        verticalAlign: 'middle',
    },
    addCell: {
        width: '36px',
        padding: '6px 0',
        verticalAlign: 'middle',
        textAlign: 'center',
    },
    slotRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        marginBottom: '4px',
    },
    timePicker: {
        width: '100px',
    },
    separator: {
        color: '#999',
        fontSize: '16px',
        lineHeight: '1',
    },
    emptyHint: {
        color: '#bbb',
        fontSize: '12px',
        fontStyle: 'italic',
        lineHeight: '24px',
    },
};

class OpeningHours extends React.Component {
    getSlotsForDay = (wochentag) => {
        const value = this.props.value || [];
        return value
            .map((slot, index) => ({...slot, _index: index}))
            .filter(slot => slot.wochentag === wochentag);
    };

    addSlot = (wochentag) => {
        const value = this.props.value || [];
        this.props.onChange([...value, {wochentag, von: '', bis: ''}]);
    };

    removeSlot = (globalIndex) => {
        const value = this.props.value || [];
        this.props.onChange(value.filter((_, i) => i !== globalIndex));
    };

    updateSlot = (globalIndex, field, newVal) => {
        const value = this.props.value || [];
        this.props.onChange(
            value.map((slot, i) => i === globalIndex ? {...slot, [field]: newVal} : slot)
        );
    };

    render() {
        const disabled = this.props.disabled || false;
        const showSeparator = !!this.props.schemaOptions?.show_separator;
        const sectionTitle = this.props.schemaOptions?.section_title?.value;

        return (
            <div style={showSeparator ? styles.wrapper : undefined}>
            {sectionTitle && (
                <div style={styles.dividerWrapper}>
                    <Divider>{sectionTitle}</Divider>
                </div>
            )}
            <div style={styles.tableWrapper}>
            <table style={styles.table}>
                <tbody>
                    {DAYS.map(day => {
                        const slots = this.getSlotsForDay(day.value);
                        return (
                            <tr key={day.value} style={styles.row}>
                                <td style={styles.dayCell}>{day.label}</td>
                                <td style={styles.slotsCell}>
                                    {slots.length === 0 && (
                                        <span style={styles.emptyHint}>Kein Eintrag</span>
                                    )}
                                    {slots.map(slot => (
                                        <div key={slot._index} style={styles.slotRow}>
                                            <div style={styles.timePicker}>
                                                <DatePicker
                                                    value={timeToDate(slot.von)}
                                                    disabled={disabled}
                                                    onChange={(date) => this.updateSlot(slot._index, 'von', dateToTime(date))}
                                                    options={TIME_PICKER_OPTIONS}
                                                />
                                            </div>
                                            <span style={styles.separator}>–</span>
                                            <div style={styles.timePicker}>
                                                <DatePicker
                                                    value={timeToDate(slot.bis)}
                                                    disabled={disabled}
                                                    onChange={(date) => this.updateSlot(slot._index, 'bis', dateToTime(date))}
                                                    options={TIME_PICKER_OPTIONS}
                                                />
                                            </div>
                                            {!disabled && (
                                                <Tooltip label="Eintrag entfernen">
                                                    <Button
                                                        icon="su-times"
                                                        skin="icon"
                                                        onClick={() => this.removeSlot(slot._index)}
                                                    />
                                                </Tooltip>
                                            )}
                                        </div>
                                    ))}
                                </td>
                                <td style={styles.addCell}>
                                    {!disabled && (
                                        <Tooltip label="Zeit hinzufügen">
                                            <Button
                                                icon="su-plus"
                                                skin="icon"
                                                onClick={() => this.addSlot(day.value)}
                                            />
                                        </Tooltip>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            </div>
            </div>
        );
    }
}

export default OpeningHours;
